import { lazy } from 'react';

import { TopBar } from '@app/shared/ui/molecules/Common';
import { useGetCurrentUserQuery } from '@app/store/slices/users/usersApi';

const ReferralTreeFlow = lazy(
  () => import('@app/shared/ui/organisms/ReferralTree/ReferralTreeFlow')
);

export default function ReferralTreePage() {
  const { data: user } = useGetCurrentUserQuery();

  return (
    <div className="flex h-full flex-col pb-5 pt-3">
      <TopBar translationKey="referral_tree.title" />
      {user && <ReferralTreeFlow userId={user.id} />}
    </div>
  );
}
